import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  addBalance: 'اضف رصيد',
  addBalanceNow: 'اضف رصيد الان',
  noTransactionsFound: 'لا يوجد معاملات',
  addedBalance: 'الرصيد تم شحنه ',
  balanceDeducted: 'الرصيد تم سحبه ',
  currentBalance: ' الرصيد المتاح للاستخدام',
  allTime: 'جميع الاوقات',
  lastDay: 'آخر يوم',
  lastWeek: 'آخر ٧ ايام',
  lastMonth: 'آخر شهر',
  customDate: 'وقت محدد',
  filterResultsByDate: 'تصفية النتائج حسب',
  all: 'الكل',
  payments: 'المدفوع',
  topUps: 'الشحن',
  balanceValue: 'قيمة الرصيد',
  priceWithVat: 'السعر بعد  الضريبة: ',
  paymentSummary: 'ملخص الدفع',
  editSearchCriteria: 'يرجى تعديل معايير البحث أو إضافة معاملات جديدة',
  topupSummary: 'ملخص الدفع',
  topupDetails: 'بيانات الدفع',
});
